/**
 * Converts URLs in text to clickable anchor tags with parameter encoding for TurboDebt links
 * @param {string} text - The text containing URLs
 * @returns {string} - The text with URLs converted to anchor tags
 */
export function convertLinksToAnchors(text) {
  if (!text || typeof text !== 'string') {
    return text
  }

  // URL regex pattern that matches http, https, and www URLs
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g

  // Get current URL parameters if they exist
  let currentParams = ''
  let hasLParam = false
  try {
    if (typeof window !== 'undefined') {
      const lParam = new URLSearchParams(window.location.search).get('l')

      if (lParam) {
        hasLParam = true
        try {
          const decodedUrl = atob(lParam)
          const paramsMatch = decodedUrl.match(/params=([^&]*)/)
          if (paramsMatch) {
            currentParams = paramsMatch[1]
          }
        } catch (e) {
          console.error('Error decoding l parameter:', e)
        }
      }
    }
  } catch (e) {
    console.error('Error getting URL params:', e)
  }

  return text.replace(urlRegex, (url) => {
    let href = url.startsWith('www.') ? `https://${url}` : url

    // Check if the URL contains turbodebt.com/thanks and we have params from l parameter
    if (href.includes('turbodebt.com/thanks') && hasLParam && currentParams) {
      try {
        /** @type {Record<string, string>} */
        const paramsObj = {}
        const searchParams = new URLSearchParams(
          decodeURIComponent(currentParams),
        )
        searchParams.forEach((value, key) => {
          paramsObj[key] = value
        })

        const structuredData = {
          name: paramsObj.firstname
            ? `${paramsObj.firstname} ${paramsObj.lastname || ''}`.trim()
            : '',
          first: paramsObj.firstname || '',
          last: paramsObj.lastname || '',
          email: paramsObj.email || '',
          zipcode: paramsObj.zipcode || '',
          phone: paramsObj.phone || '',
          state: paramsObj.state || '',
          sub1: paramsObj.sub_1 || '',
          utmCampaign: paramsObj.utm_campaign || '',
          affId: paramsObj.aff_id || '',
          debtOwed: paramsObj.debt_amount || '',
        }
        // will need to ask BE to add email, zip etc...

        const encodedData = btoa(JSON.stringify(structuredData))

        const separator = href.includes('?') ? '&' : '?'
        href = `${href}${separator}params=${encodedData}`
      } catch (e) {
        console.error('Error encoding params:', e)
      }
    }

    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`
  })
}
